import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV, LegacyResolvers } from "../../../common_nextgen/utils/UtilFunctions";

const useCouponPatientPayGPIListPlans = () => {
  const {
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.COUPON_PATIENT_PAY_GPI_LIST,
    currentIndex: initialIndex = 0,
    initialParamsData = {
      pxcCouponPatPayGpiLst: selectedSchedules[initialIndex].cpfGpiListName,
      cpfGpiListDescription:
        selectedSchedules[initialIndex].cpfGpiListDescription,
      planCode: "",
      planEffDate: "",
      hiddenRecordIndicator: "A",
    },
  } = currentState;
  console.log("InitialparamsData", initialParamsData, previousState);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const toast = useToast();

  const screen_title = "Coupon Patient Pay GPI List Plans";
  const screenNumber = "RCPXC012";

  const formFields = [
    {
      fieldLabel: "PXC Coupon PatPay GPI Lst",
      name: "pxcCouponPatPayGpiLst",
      label: "List",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "CPF GPI List Description",
      name: "cpfGpiListDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 30,
    },
    {
      fieldLabel: "Plan Code",
      name: "planCode",
      label: "Plan Code",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Plan Eff Date",
      name: "planEffDate",
      label: "From Date",
      type: "date",
      fieldNature: "editable",
      maxLength: 7,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      maxLength: 20,
    },
  ];

  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        // console.log(rowData,"rowdata")
        const { formatDateForPresto } = LegacyResolvers;
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPLN009",
          parameters: {
            planCode: rowData["planCode"],
            planEffDate: formatDateForPresto(rowData["planEffDate"]),
            restrictDefaultCarrier: "",
          },
        };
        console.log(message, "message--");
        window.top?.postMessage(message, "*");
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const { formatDateForPresto } = LegacyResolvers;
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPLN013I",
          parameters: {
            planCode: rowData["planCode"],
            planEffDate: formatDateForPresto(rowData["planEffDate"]),
          },
        };
        console.log(message, "message");
        window.top?.postMessage(message, "*");
      },
    },
  ];

  const columnDef = [
    {
      header: "Plan Code",
      field: "planCode",
    },
    {
      header: "From Date",
      field: "planEffDate",
    },
    {
      header: "Description",
      field: "planName",
    },
    {
      header: "Opt Status",
      field: "optStatus",
    },
    {
      header: "List From Date",
      field: "pxcFromDate",
    },
    {
      header: "List Thru Date",
      field: "pxcThruDate",
    },
    {
      header: "List Status",
      field: "pxcStatus",
    },
  ];

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (currentIndex < selectedSchedules.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  const parmKey = "planCode";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcpxcp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
    console.log("inside use eff");
  }, [paramsData, rows, currentPage]);

  useEffect(() => {
    if (
      selectedSchedules.length > 0 &&
      (paramsData.pxcCouponPatPayGpiLst !==
        selectedSchedules[currentIndex]?.cpfGpiListName ||
        paramsData.cpfGpiListDescription !==
          selectedSchedules[currentIndex]?.cpfGpiListDescription)
    ) {
      setParamsData({
        pxcCouponPatPayGpiLst: selectedSchedules[currentIndex]?.cpfGpiListName,
        cpfGpiListDescription:
          selectedSchedules[currentIndex]?.cpfGpiListDescription,
        planCode: "",
        planEffDate: "",
        hiddenRecordIndicator: "A",
      });
    }
  }, [currentIndex, selectedSchedules, paramsData]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };
  
  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcpxcp/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    setSelectedOption,
  };
};

export default useCouponPatientPayGPIListPlans;
